export default __webpack_public_path__ + "locales/sq-AL/EmptyView.json?hash=28cc7c9ce9dd1396fbe61f862340d126";